export const IMUNOLOGIA_FINALIZADA = 'IMUNOLOGIA_FINALIZADA';
export const imunologiaFinalizada = (imunologiaFinalizada) => ({
  type: IMUNOLOGIA_FINALIZADA,
  payload: {
    imunologiaFinalizada: imunologiaFinalizada,
  },
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/imuno/imuno.action.js